import { makeGQLQuery } from "./makeGQLQuery";

/**
 * List of graphql queries
 */

export const queryUsers = makeGQLQuery({
  chunks: "{ users }",
});
